<script setup lang="ts">
import { ref, watch, useAttrs } from "vue";
import { debounce as lodashDebounce } from "lodash";

const props = withDefaults(
  defineProps<{
    modelValue: string;
    debounce?: number;
    search?: boolean;
    autofocus?: boolean;
  }>(),
  {
    debounce: 300,
    search: false,
    autofocus: false,
  }
);

const inputRef = ref<InstanceType<typeof HTMLInputElement> | null>(null);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const attrs = useAttrs();

const localValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    localValue.value = newVal;
  }
);

const debouncedEmit = lodashDebounce((value: string) => {
  emit("update:modelValue", value);
}, props.debounce);

watch(localValue, (newVal) => {
  debouncedEmit(newVal);
});

watch(
  inputRef,
  (newVal) => {
    if (newVal?.focus && props.autofocus) {
      setTimeout(() => {
        newVal.focus();
      }, 100);
    }
  },
  { immediate: true }
);
</script>

<template>
  <el-input ref="inputRef" v-model="localValue" v-bind="attrs">
    <template v-if="search" #prefix>
      <i class="bi-search"></i>
    </template>
  </el-input>
</template>
